import React, { useState } from "react";
import { Row, Col, Button, Form, Collapse } from "react-bootstrap";
import NumberFormat from "react-number-format";
import {
  CLASS,
  COMMODITY,
  savePrice,
  selectPrice,
  getStateFromZip,
  setTier,
  TIERS,
  getUtilitiesFromZip,
  getRateCodes,
  COMMODITIES_LIST,

} from "../GetPrice";
import { useDispatch, useSelector } from "react-redux";
import { ALL_SUPPLIERS, GREENPERCENTS, MONTHLYUSAGES ,SELECT_SUPPLIERS } from "./showPrice.constants";
import Overlay from "../../widgets/Tooltip";
import classNames from "classnames";
import { selectPortalSetting, setSupplierPricesTriggeredFromGetPrices } from "../GetPrice";
import { circleInfo } from "../../features/base64/images.constants";
import { filter } from "lodash";

const ShowMoreFilters = ({
  filterInfo,
  setFilterInfo,
  setInfo,
  setLocalZipCode,
  info,
  localZipCode,
  suppliers,
  brokerageId,
  filters,
  setIsSupplierUpdated,
  setShowUtilityError,
  utilities,
  handleUtility
}) => {
  const dispatch = useDispatch();
  const [moreFiltersOn, setMoreFiltersOn] = useState(false);
  const [isClassChanged, setIsClassChanged] = useState(true)
  const [selectedGreenPercent, setSelectedGreenPerecent] = useState("Green Percentage");
  const basicInfo = useSelector(selectPrice);
  const calculateMonthlyUsage = () => { let defaultUsagePM = basicInfo.usage / 12;
  if (defaultUsagePM >= 0 && defaultUsagePM <= 500) {
    return MONTHLYUSAGES[0].value;
  } else if (defaultUsagePM >= 501 && defaultUsagePM <= 1000) {
    return MONTHLYUSAGES[1].value;
  } else {
    return MONTHLYUSAGES[2].value;
  }
  };
  const handleUsage = (usage) => {
    if (usage == 500) {
      return "Small House or Appartment, less than ≈ 1000 sqft";
    } else if (usage == 1000) {
      return "Medium House or Appartment, between ≈ 1000 - 2000 sqft";
    } else if(usage == 2000) {
      return "Large House, larger than ≈ 3000 sqft";
    }
  };
  const [usage, setUsage] = useState(basicInfo.usage ? calculateMonthlyUsage() : 0);
  const [selectedMonthlyUsage, setSelectedMonthlyUsage] =useState(basicInfo.usage ? calculateMonthlyUsage() : 0);
  const [usageLabel, setUsageLabel] = useState(handleUsage(calculateMonthlyUsage()));
  const portalSettings = useSelector(selectPortalSetting);

  const handleZipCode = (zipCode) => {
    dispatch(savePrice({ ...basicInfo, zipCode: zipCode }));
  };


  const getSuppliers = (supplierName) => {
    const selectedSupplierId = suppliers.find(
      (supplierData) => supplierData.SupplierName === supplierName
    );
    if (selectedSupplierId) return [selectedSupplierId.SupplierId];
    return suppliers.map((supplierId) => supplierId.SupplierId);
  };

  return (
    <>
      <Collapse in={moreFiltersOn}>
        <div>
          {filters.class === CLASS.COMMERCIAL ? 
            <>
              <Row className="mx-n1">
            <Col xl={4} lg={5} md={8} className="px-1 mb-3 mb-lg-0 mt-2">
              <div className="d-flex align-items-center">
                <span className="f-14 mr-2 text-nowrap">Contract Length</span>
                <NumberFormat
                  type="text"
                  className="f-14 form-control"
                  onChange={(e) =>
                    setFilterInfo({
                      ...filterInfo,
                      from: e.target.value,
                    })
                  }
                  onBlur={() => {
                    const formattedValue = parseInt(filterInfo.to) >= parseInt(filterInfo.from) || !filterInfo.to ? filterInfo.from : ""
                    setFilterInfo({
                      ...filterInfo,
                      from: formattedValue,
                    })
                  }}
                  value={filterInfo.from}
                  allowNegative={false}
                />
                <span className="f-14 px-1">To</span>
                <NumberFormat
                  type="text"
                  className="f-14 form-control"
                  onChange={(e) =>
                    setFilterInfo({
                      ...filterInfo,
                      to: e.target.value,
                    })
                  }
                  onBlur={() => {
                    const formattedValue = parseInt(filterInfo.to) >= parseInt(filterInfo.from) || !filterInfo.from ? filterInfo.to : ""
                    setFilterInfo({
                      ...filterInfo,
                      to: formattedValue,
                    })
                  }}
                  value={filterInfo.to}
                  allowNegative={false}
                />
                <span className="f-14 px-1">Months</span>
              </div>
            </Col>
            <Col xl={3} lg={2} md={4} className="px-1 mb-3 mb-lg-0 mt-lg-2 mt-md-2">
              <Form.Control
                as="select"
                className="f-14"
                onChange={(e) => {
                  const value = e.target.value;
                  setFilterInfo({
                    ...filterInfo,
                    supplier: value,
                    Suppliers: getSuppliers(value),
                  });
                }}
              >
                {suppliers.length === 1 && <option value={suppliers[0].SupplierName}>{suppliers[0].SupplierName}</option>}
                {suppliers.length !== 1 && <option value={SELECT_SUPPLIERS}>Select Suppliers</option>}
                {isClassChanged && suppliers.length !== 1 && suppliers.map((supplier, index) => (
                  <option key={index} value={supplier.SupplierName}>
                    {supplier.SupplierName}
                  </option>
                ))}
              </Form.Control>
            </Col>
            <Col xl={1} lg={2} md={4} className="px-1 mb-3 mb-md-0 mb-lg-0 mt-lg-2">
              <NumberFormat
                type="text"
                allowLeadingZeros={true}
                placeholder="Zip Code"
                className="f-14 form-control"
                value={filterInfo.zipCode || localZipCode}
                onChange={(e) => {
                  setLocalZipCode(e.target.value);
                  setFilterInfo({
                    ...filterInfo,
                    zipCode: e.target.value,
                  });
                }}
                allowNegative={false}
                maxLength={100}
              />
              {localZipCode && localZipCode.length < 5 && (
                <div className="error-message mt-1">
                  Zip Code must contain at least 5 digits.
                </div>
              )}
            </Col>
            {portalSettings.showClassSelection ? (
              <Col xl={2} lg={6} md={6} className="px-1 mb-0 d-flex mt-lg-2">
                <div className="radio-group d-inline-flex mb-1 w-100">
                    <Form.Label className="mb-0 radio-group-item w-50">
                      <Form.Control type="radio" name="class" className="d-none" />
                      <Overlay content={CLASS.RESIDENTIAL}>
                        <Button
                          variant={
                            info.class === CLASS.RESIDENTIAL
                              ? "primary"
                              : "outline-primary"
                          }
                          className="tab-btn btn-custom-left w-100"
                          onClick={() => {
                            dispatch(setSupplierPricesTriggeredFromGetPrices(true));
                            dispatch(setIsSupplierUpdated(true));
                            setInfo({
                              ...info,
                              class: CLASS.RESIDENTIAL,
                            });
                            setFilterInfo({
                              ...filterInfo,
                              supplier: ALL_SUPPLIERS,
                              Suppliers: [],
                              class: CLASS.RESIDENTIAL,
                            });
                            setIsClassChanged(filters.class === CLASS.RESIDENTIAL)
                            dispatch(setTier(TIERS.SMALL));
                          }}
                        >
                          <i className="fa fa-home fa-lg"></i>
                        </Button>
                      </Overlay>
                    </Form.Label>

                    <Form.Label className="mb-0 radio-group-item w-50">
                      <Form.Control type="radio" name="class" className="d-none" />
                      <Overlay content={CLASS.COMMERCIAL}>
                        <Button
                          variant={
                            info.class === CLASS.COMMERCIAL
                              ? "primary"
                              : "outline-primary"
                          }
                          className="tab-btn btn-custom-right w-100"
                          onClick={(e) => {
                            dispatch(setSupplierPricesTriggeredFromGetPrices(true));
                            dispatch(setIsSupplierUpdated(true));
                            setFilterInfo({
                              ...filterInfo,
                              supplier: ALL_SUPPLIERS,
                              Suppliers: [],
                              class: CLASS.COMMERCIAL,
                            });
                            setIsClassChanged(filters.class === CLASS.COMMERCIAL)
                            setInfo({
                              ...info,
                              class: CLASS.COMMERCIAL,
                            });
                          }}
                        >
                          <i className="fa fa-building fa-lg"></i>
                        </Button>
                      </Overlay>
                    </Form.Label>
                  </div>
              </Col>
            ) : (<></>)}
            {portalSettings.showCommoditySelection ? (
              <Col xl={2} lg={6} md={6} className="px-1 mb-0 d-flex mt-lg-2">
                <div className="radio-group d-inline-flex mb-1 w-100 ml-2">
                  <Form.Label className="mb-0 radio-group-item w-50">
                    <Form.Control
                      type="radio"
                      name="commodity"
                      className="d-none"
                    />
                    <Overlay content="Electricity">
                      <Button
                        variant={
                          info.commodity === COMMODITY.ELECTRIC
                            ? "primary"
                            : "outline-primary"
                        }
                        className="tab-btn btn-custom-left w-100"
                        onClick={() => {
                          dispatch(setSupplierPricesTriggeredFromGetPrices(true));
                          dispatch(setIsSupplierUpdated(true));
                          setInfo({
                            ...info,
                            commodity: COMMODITY.ELECTRIC,
                          });
                          setFilterInfo({
                            ...filterInfo,
                            commodity: COMMODITY.ELECTRIC,
                          });
                        }}
                      >
                        <i className="fa fa-bolt fa-lg"></i>
                      </Button>
                    </Overlay>
                  </Form.Label>

                  <Form.Label className="mb-0 radio-group-item w-50">
                    <Form.Control
                      type="radio"
                      name="commodity"
                      className="d-none"
                    />
                    <Overlay content="Gas">
                      <Button
                        variant={
                          info.commodity === COMMODITY.NAT_GAS
                            ? "primary"
                            : "outline-primary"
                        }
                        className="tab-btn btn-custom-right w-100"
                        onClick={() => {
                          dispatch(setSupplierPricesTriggeredFromGetPrices(true));
                          dispatch(setIsSupplierUpdated(true));
                          setInfo({
                            ...info,
                            commodity: COMMODITY.NAT_GAS,
                          });
                          setFilterInfo({
                            ...filterInfo,
                            commodity: COMMODITY.NAT_GAS,
                          });
                        }}
                      >
                        <i className="fa fa-fire fa-lg"></i>
                      </Button>
                    </Overlay>
                  </Form.Label>
                </div>
              </Col>
            ) : (<></>)}
            {!!portalSettings.showClassSelection === false &&
                  !!portalSettings.showCommoditySelection === false && (
                    <Col xl={2} lg={0} md={0}></Col>
                  )}
                {!(
                  portalSettings.showClassSelection &&
                  portalSettings.showCommoditySelection
                ) && (
                  <Col xl={2} lg={0} md={0} className="px-1 mb-0 d-flex mt-2">
                    <div className="mb-1 w-100">
                      <Button
                        variant="primary"
                        className="f-14 btn-block tab-btn btn-custom-left w-100 custom-height"
                        disabled={localZipCode && localZipCode.length < 5}
                        onClick={() => {
                          dispatch(getStateFromZip({ zipcode: localZipCode }));
                          handleZipCode(localZipCode, filters);
                          if (
                            localZipCode.length >= 5 &&
                            filterInfo.class === CLASS.COMMERCIAL &&
                            (!isClassChanged ||
                              filters.zipCode !== localZipCode ||
                              filters.commodity !== filterInfo.commodity)
                          )
                            dispatch(
                              getUtilitiesFromZip({
                                zipcode: localZipCode,
                                commodityId: filterInfo.commodity,
                              })
                            ).then((res) => {
                              if (res.payload) {
                                if (res.payload.length === 0) {
                                  setShowUtilityError(true);
                                  setFilterInfo({
                                    ...filterInfo,
                                    isFilterUpdated: true,
                                    utility: res.payload[0],
                                    zipCode: localZipCode,
                                  });
                                  return;
                                }
                                setShowUtilityError(false);
                                dispatch(
                                  getRateCodes({
                                    filters: {
                                      LDCIdentifiers: [
                                        res.payload[0].LDCIdentifier,
                                      ],
                                      Commodity:
                                        COMMODITIES_LIST[filterInfo.commodity],
                                      StateId: basicInfo.state.id,
                                      StateName: basicInfo.state.name,
                                      ZipCode: localZipCode,
                                      BrokerId: brokerageId,
                                      RateClassification: filterInfo.class,
                                    },
                                  })
                                ).then((response) => {
                                  if (response) {
                                    dispatch(
                                      savePrice({
                                        ...basicInfo,
                                        rateCode: "",
                                      })
                                    );
                                    setFilterInfo({
                                      ...filterInfo,
                                      isFilterUpdated: true,
                                      utility: res.payload[0],
                                      zipCode: localZipCode,
                                    });
                                  }
                                });
                              }
                            });
                          else if (
                            localZipCode.length >= 5 &&
                            filterInfo.class === CLASS.RESIDENTIAL &&
                            !isClassChanged &&
                            filters.zipcode !== localZipCode &&
                            filters.commodityId !== filterInfo.commodity
                          ) {
                            dispatch(
                              getRateCodes({
                                filters: {
                                  LDCIdentifiers: [],
                                  Commodity:
                                    COMMODITIES_LIST[filterInfo.commodity],
                                  StateId: basicInfo.state.id,
                                  StateName: basicInfo.state.name,
                                  ZipCode: localZipCode,
                                  BrokerId: brokerageId,
                                  RateClassification: filterInfo.class,
                                },
                              })
                            ).then((res) => {
                              if (res) {
                                dispatch(
                                  savePrice({
                                    ...basicInfo,
                                    rateCode: "",
                                  })
                                );
                                setFilterInfo({
                                  ...filterInfo,
                                  isFilterUpdated: true,
                                  utility: {},
                                  zipCode: localZipCode,
                                });
                              }
                            });
                          } else
                            setFilterInfo({
                              ...filterInfo,
                              isFilterUpdated: true,
                            });
                          setIsClassChanged(true);
                        }}
                      >
                        Search
                      </Button>
                    </div>
                  </Col>)}
          </Row>
          {!!(
            portalSettings.showClassSelection &&
            portalSettings.showCommoditySelection
          ) && (
            <Row>
              <Col xl={10}></Col>
              <Col xl={2} lg={2} md={4} sm={12} className="btn-px">
              <span>
                <Button
                  variant="primary"
                  className="f-14 btn-block my-2"
                  disabled={localZipCode && localZipCode.length < 5}
                  onClick={() => {
                    dispatch(getStateFromZip({ zipcode: localZipCode }));
                    handleZipCode(localZipCode, filters);
                    if (
                      localZipCode.length >= 5 &&
                      filterInfo.class === CLASS.COMMERCIAL &&
                      (!isClassChanged ||
                        filters.zipCode !== localZipCode ||
                        filters.commodity !== filterInfo.commodity)
                    )
                      dispatch(
                        getUtilitiesFromZip({
                          zipcode: localZipCode,
                          commodityId: filterInfo.commodity,
                        })
                      ).then((res) => {
                        if (res.payload) {
                          if (res.payload.length === 0) {
                            setShowUtilityError(true);
                            setFilterInfo({
                              ...filterInfo,
                              isFilterUpdated: true,
                              utility: res.payload[0],
                              zipCode: localZipCode,
                            });
                            return;
                          }
                          setShowUtilityError(false);
                          dispatch(
                            getRateCodes({
                              filters: {
                                LDCIdentifiers: [res.payload[0].LDCIdentifier],
                                Commodity:
                                  COMMODITIES_LIST[filterInfo.commodity],
                                StateId: basicInfo.state.id,
                                StateName: basicInfo.state.name,
                                ZipCode: localZipCode,
                                BrokerId: brokerageId,
                                RateClassification: filterInfo.class,
                              },
                            })
                          ).then((response) => {
                            if (response) {
                              dispatch(
                                savePrice({
                                  ...basicInfo,
                                  rateCode: "",
                                })
                              );
                              setFilterInfo({
                                ...filterInfo,
                                isFilterUpdated: true,
                                utility: res.payload[0],
                                zipCode: localZipCode,
                              });
                            }
                          });
                        }
                      });
                    else if (
                      localZipCode.length >= 5 &&
                      filterInfo.class === CLASS.RESIDENTIAL &&
                      !isClassChanged &&
                      filters.zipcode !== localZipCode &&
                      filters.commodityId !== filterInfo.commodity
                    ) {
                      dispatch(
                        getRateCodes({
                          filters: {
                            LDCIdentifiers: [],
                            Commodity: COMMODITIES_LIST[filterInfo.commodity],
                            StateId: basicInfo.state.id,
                            StateName: basicInfo.state.name,
                            ZipCode: localZipCode,
                            BrokerId: brokerageId,
                            RateClassification: filterInfo.class,
                          },
                        })
                      ).then((res) => {
                        if (res) {
                          dispatch(
                            savePrice({
                              ...basicInfo,
                              rateCode: "",
                            })
                          );
                          setFilterInfo({
                            ...filterInfo,
                            isFilterUpdated: true,
                            utility: {},
                            zipCode: localZipCode,
                          });
                        }
                      });
                    } else
                      setFilterInfo({
                        ...filterInfo,
                        isFilterUpdated: true,
                      });
                    setIsClassChanged(true);
                  }}
                >
                  Search
                </Button>
              </span>
            </Col>
          </Row>
          )}
            </> 
          : ""}
          {filters.class === CLASS.RESIDENTIAL ? <Row className="mx-n1">
              <Col
                xl={3}
                lg={12}
                md={12}
                className="px-1 mb-3 mb-md-0 mb-lg-0 mt-lg-2"
              >
                <div className="rangeLayoutRows">
                  <div className="rangeLayout">
                    <div>
                      {"Estimated Monthly Usage "}
                      <Overlay
                        content={
                          "Anticipated energy consumption for a single month. Helps in planning for monthly energy expenses"
                        }
                      >
                        <img src={circleInfo} x="0" y="0" height="14px" width="14px" />
                      </Overlay>
                    </div>
                    <div></div>
                    <div className="align-items-left justify-content-left">
                      <Form.Control
                        as="select"
                        className="f-14"
                        onChange={(e) => {
                          setUsageLabel(handleUsage(e.target.value));
                          setSelectedMonthlyUsage(e.target.value);
                          let usage = e.target.value * 12;
                          setFilterInfo({
                            ...filterInfo,
                            usage: usage,
                          });
                        }}
                        value={selectedMonthlyUsage}
                      >
                        {MONTHLYUSAGES.map((usage, index) => (
                          <option key={index} value={usage.value}>
                            {usage.label}
                          </option>
                        ))}
                      </Form.Control>
                    </div>
                  </div>
                  <div>
                      <span className="f-14">*{usageLabel}</span>
                  </div>
                </div>
              </Col>
            <Col xl={3}  lg={12} md={12}  className="px-1 mb-3 mb-md-0 mb-lg-0 mt-lg-2">
              <div  
                className="rangeLayout"
              >
                <div>
                {"Green Percentage "}<Overlay content={"Shows how much eco-friendly energy is used. It's all about sustainability!"}><img src={circleInfo} x="0" y="0" height="14px" width="14px" /></Overlay>
                </div>
                <div></div>
                <div>
                  <Form.Control
                    as="select"
                    className="f-14"
                    onChange={(e) => {
                      setSelectedGreenPerecent(e.target.value);
                      setFilterInfo({
                        ...filterInfo,
                        greenPercentage: e.target.value,
                      });
                    }}
                    value={selectedGreenPercent}
                  >
                    {GREENPERCENTS.map((percent, index) => (
                      <option key={index} value={percent.value}>
                        {percent.label}
                      </option>
                    ))}
                    <option disabled value={"Green Percentage"}>
                      {"Select Green Percentage"}
                    </option>
                  </Form.Control>
                </div>
              </div>
            </Col>
              {portalSettings.showClassSelection ? (
              <Col xl={2} lg={12} md={12} className="px-1 mb-0 d-flex mt-lg-2">
                <div className="radio-group d-inline-flex mb-1 w-100">
                  <Form.Label className="mb-0 radio-group-item w-50">
                    <Form.Control
                      type="radio"
                      name="class"
                      className="d-none"
                    />
                    <Overlay content={CLASS.RESIDENTIAL}>
                      <Button
                        variant={
                          info.class === CLASS.RESIDENTIAL
                            ? "primary"
                            : "outline-primary"
                        }
                        className="tab-btn btn-custom-left w-100"
                        onClick={() => {
                          dispatch(setSupplierPricesTriggeredFromGetPrices(true));
                          dispatch(setIsSupplierUpdated(true));
                          setInfo({
                            ...info,
                            class: CLASS.RESIDENTIAL,
                          });
                          setFilterInfo({
                            ...filterInfo,
                            supplier: ALL_SUPPLIERS,
                            Suppliers: [],
                            class: CLASS.RESIDENTIAL,
                          });
                          setIsClassChanged(
                            filters.class === CLASS.RESIDENTIAL
                          );
                          dispatch(setTier(TIERS.SMALL));
                        }}
                      >
                        <i className="fa fa-home fa-lg"></i>
                      </Button>
                    </Overlay>
                  </Form.Label>

                  <Form.Label className="mb-0 radio-group-item w-50">
                    <Form.Control
                      type="radio"
                      name="class"
                      className="d-none"
                    />
                    <Overlay content={CLASS.COMMERCIAL}>
                      <Button
                        variant={
                          info.class === CLASS.COMMERCIAL
                            ? "primary"
                            : "outline-primary"
                        }
                        className="tab-btn btn-custom-right w-100"
                        onClick={(e) => {
                          dispatch(setSupplierPricesTriggeredFromGetPrices(true));
                          dispatch(setIsSupplierUpdated(true));
                          setFilterInfo({
                            ...filterInfo,
                            supplier: ALL_SUPPLIERS,
                            Suppliers: [],
                            class: CLASS.COMMERCIAL,
                          });
                          setIsClassChanged(filters.class === CLASS.COMMERCIAL);
                          setInfo({
                            ...info,
                            class: CLASS.COMMERCIAL,
                          });
                        }}
                      >
                        <i className="fa fa-building fa-lg"></i>
                      </Button>
                    </Overlay>
                  </Form.Label>
                </div>
              </Col>
              ) : (<></>)}

              {portalSettings.showCommoditySelection ? (
                <Col xl={2} lg={6} md={6} className="px-1 mb-0 d-flex mt-lg-2">
                  <div className="radio-group d-inline-flex mb-1 w-100 ml-2">
                    <Form.Label className="mb-0 radio-group-item w-50">
                      <Form.Control
                        type="radio"
                        name="commodity"
                        className="d-none"
                      />
                      <Overlay content="Electricity">
                        <Button
                          variant={
                            info.commodity === COMMODITY.ELECTRIC
                              ? "primary"
                              : "outline-primary"
                          }
                          className="tab-btn btn-custom-left w-100"
                          onClick={() => {
                            dispatch(setSupplierPricesTriggeredFromGetPrices(true));
                            dispatch(setIsSupplierUpdated(true));
                            setInfo({
                              ...info,
                              commodity: COMMODITY.ELECTRIC,
                            });
                            setFilterInfo({
                              ...filterInfo,
                              commodity: COMMODITY.ELECTRIC,
                            });
                          }}
                        >
                          <i className="fa fa-bolt fa-lg"></i>
                        </Button>
                      </Overlay>
                    </Form.Label>

                    <Form.Label className="mb-0 radio-group-item w-50">
                      <Form.Control
                        type="radio"
                        name="commodity"
                        className="d-none"
                      />
                      <Overlay content="Gas">
                        <Button
                          variant={
                            info.commodity === COMMODITY.NAT_GAS
                              ? "primary"
                              : "outline-primary"
                          }
                          className="tab-btn btn-custom-right w-100"
                          onClick={() => {
                            dispatch(setSupplierPricesTriggeredFromGetPrices(true));
                            dispatch(setIsSupplierUpdated(true));
                            setInfo({
                              ...info,
                              commodity: COMMODITY.NAT_GAS,
                            });
                            setFilterInfo({
                              ...filterInfo,
                              commodity: COMMODITY.NAT_GAS,
                            });
                          }}
                        >
                          <i className="fa fa-fire fa-lg"></i>
                        </Button>
                      </Overlay>
                    </Form.Label>
                  </div>
                </Col>
              ) : (<></>)}
              {!portalSettings.showClassSelection ? <Col xl={2} lg={0} md={0}></Col> : <></>}
              {!portalSettings.showCommoditySelection ? <Col xl={2} lg={0} md={0}></Col> : <></>}
              <Col xl={2} lg={0} md={0} className="px-1 mb-0 d-flex mt-2">
                  <div className="mb-1 w-100">
                    <Button
                      variant="primary"
                      className="f-14 btn-block tab-btn btn-custom-left w-100 custom-height"
                      disabled={localZipCode && localZipCode.length < 5}
                      onClick={() => {
                        dispatch(getStateFromZip({ zipcode: localZipCode }));
                        handleZipCode(localZipCode, filters);
                        if (
                          localZipCode.length >= 5 &&
                          filterInfo.class === CLASS.COMMERCIAL &&
                          (!isClassChanged ||
                            filters.zipCode !== localZipCode ||
                            filters.commodity !== filterInfo.commodity)
                        )
                          dispatch(
                            getUtilitiesFromZip({
                              zipcode: localZipCode,
                              commodityId: filterInfo.commodity,
                            })
                          ).then((res) => {
                            if (res.payload) {
                              if (res.payload.length === 0) {
                                setShowUtilityError(true);
                                setFilterInfo({
                                  ...filterInfo,
                                  isFilterUpdated: true,
                                  utility: res.payload[0],
                                  zipCode: localZipCode,
                                });
                                return;
                              }
                              setShowUtilityError(false);
                              dispatch(
                                getRateCodes({
                                  filters: {
                                    LDCIdentifiers: [
                                      res.payload[0].LDCIdentifier,
                                    ],
                                    Commodity:
                                      COMMODITIES_LIST[filterInfo.commodity],
                                    StateId: basicInfo.state.id,
                                    StateName: basicInfo.state.name,
                                    ZipCode: localZipCode,
                                    BrokerId: brokerageId,
                                    RateClassification: filterInfo.class,
                                  },
                                })
                              ).then((response) => {
                                if (response) {
                                  dispatch(
                                    savePrice({
                                      ...basicInfo,
                                      rateCode: "",
                                    })
                                  );
                                  setFilterInfo({
                                    ...filterInfo,
                                    isFilterUpdated: true,
                                    utility: res.payload[0],
                                    zipCode: localZipCode,
                                  });
                                }
                              });
                            }
                          });
                        else if (
                          localZipCode.length >= 5 &&
                          filterInfo.class === CLASS.RESIDENTIAL &&
                          !isClassChanged &&
                          filters.zipcode !== localZipCode &&
                          filters.commodityId !== filterInfo.commodity
                        ) {
                          dispatch(
                            getRateCodes({
                              filters: {
                                LDCIdentifiers: [],
                                Commodity:
                                  COMMODITIES_LIST[filterInfo.commodity],
                                StateId: basicInfo.state.id,
                                StateName: basicInfo.state.name,
                                ZipCode: localZipCode,
                                BrokerId: brokerageId,
                                RateClassification: filterInfo.class,
                              },
                            })
                          ).then((res) => {
                            if (res) {
                              dispatch(
                                savePrice({
                                  ...basicInfo,
                                  rateCode: "",
                                })
                              );
                              setFilterInfo({
                                ...filterInfo,
                                isFilterUpdated: true,
                                utility: {},
                                zipCode: localZipCode,
                              });
                            }
                          });
                        } else
                          setFilterInfo({
                            ...filterInfo,
                            isFilterUpdated: true,
                          });
                        setIsClassChanged(true);
                      }}
                    >
                      Search
                    </Button>
                  </div>
                </Col>
          </Row> : <></>}
        </div>
      </Collapse>
      <Row className="mb-2">
        <Col lg={10} md={9} />
        <Col lg={2} md={3} className="d-flex">
          <Button
            variant="link"
            className={`f-14 ml-auto accordion_button pb-0 pt-0`}
            onClick={() => setMoreFiltersOn((prevValue) => !prevValue)}
          >
            {moreFiltersOn ? "Fewer" : "More"} Filters
            <i
              className={classNames("fa fa-chevron-up ml-2", {
                "fa-chevron-down": !moreFiltersOn,
              })}
            />
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default ShowMoreFilters;
